<template>
    <div class="d-flex flex-column align-items-center">
        <h6 class="text-uppercase text-muted font-weight-bold "> {{title}}</h6>
        <div class="ml-n3" v-show="chartData !== undefined && chartData.length>0" :id="'donutChart' + title"></div>
        <div v-if="chartData === undefined || chartData.length===0" class="d-flex align-items-center text-invalid"
             style="height: 145px">{{$t('COMMON.NO_DATA')}}
        </div>
    </div>
</template>

<script>
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4ccharts from "@amcharts/amcharts4/charts";

    export default {
        name: "wIndicators2",
        props: {
            title: {
                type: String,
                required: true
            },
            chartData: {
                type: Array,
                required: true,
            }
        },
        watch: {
            chartData: function (newVal) {
                if (this.chart !== undefined) {
                    let sum = 0;
                    this.chart.data = newVal;
                    newVal.forEach(value => {
                        sum += value.size;
                    });
                    this.label.text = "Total\n" + sum;
                }
            }
        },
        data: function () {
            return {
                chart: undefined,
                label: {},
                colors: ["#c4183c", "#37B34A", "#ffb400", "#1a1a1a"],
                opacity: 0.6,
            }
        },
        mounted() {
            am4core.options.commercialLicense = true;
            let chart = am4core.create("donutChart" + this.title, am4ccharts.PieChart);
            this.chart = chart;
            chart.data = this.chartData;
            chart.svgContainer.htmlElement.style.height = "150px";
            chart.svgContainer.htmlElement.style.width = "100%";

            chart.innerRadius = 40;
            let label = chart.seriesContainer.createChild(am4core.Label);
            this.label = label;
            label.horizontalCenter = "middle";
            label.textAlign = "middle";
            label.baseLineRatio = -1;
            label.fontSize = 20;


            if (this.chartData) {
                let sum = 0;
                this.chartData.forEach(value => {
                    sum += value.size;
                });
                this.label.text = "Total\n" + sum;
            }

            let serie = chart.series.push(new am4ccharts.PieSeries());
            serie.dataFields.value = "size";
            serie.dataFields.category = "status";
            let colorSet = new am4core.ColorSet();
            colorSet.list = this.colors.map(function (color) {
                return new am4core.color(color);
            });
            serie.tooltip.background.fillOpacity = this.opacity;

            serie.colors = colorSet;
            serie.opacity = this.opacity;
            serie.legendSettings.labelText = "{name} ([bold]{value}[\])";
            serie.legendSettings.valueText = "{noname}";
            serie.labels.template.disabled = true;
            serie.ticks.template.disabled = true;

            chart.legend = new am4ccharts.Legend();
            chart.legend.position = "right";
            chart.legend.height = 100;
            let marker = chart.legend.markers.template.children.getIndex(0);
            marker.width = 15;
            marker.height = 15;
            marker.valign = "middle";
            marker.opacity = this.opacity;

            chart.legend.markers.template.opacity = this.opacity;

            chart.legend.labels.template.maxWidth = 100;
            chart.legend.labels.template.fontSize = 12;
            chart.legend.itemContainers.template.paddingTop = 2;
            chart.legend.itemContainers.template.paddingBottom = 2;


            chart.legend.labels.template.truncate = false;
            chart.legend.labels.template.wrap = true;
            chart.legend.width = am4core.percent(90);


        },
        beforeDestroy() {
            if (this.chart) {
                this.chart.dispose();
            }
        }


    }
</script>

<style scoped>

</style>